(() => {
  const controlSelector = '[data-header-location-control]';

  function appTrigger(bridge) {
    // Multi Location Stock Info creates this div after its data loads. It is
    // the app's own drawer trigger, not a theme-created imitation.
    return bridge.querySelector('#location-popup-header-id, .location-popup-header');
  }

  function updateState(button) {
    const selected = Boolean(window.localStorage.getItem('selected_location'));
    button.classList.toggle('location-action--selected', selected);
    button.setAttribute('aria-label', selected ? 'Change store location' : 'Select a store location');
    button.title = selected ? 'Change store location' : 'Select a store location';
  }

  function openAppSelector(bridge) {
    const trigger = appTrigger(bridge);
    if (!trigger) return false;

    // The app binds a native click listener to this element.
    trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    return true;
  }

  function mountLauncher() {
    const control = document.querySelector(controlSelector);
    if (!control || control.dataset.ready === 'true') return;

    const bridge = control.querySelector('[data-location-selector-app]');
    const button = control.querySelector('[data-location-selector-launcher]');
    if (!bridge || !button) return;
    control.dataset.ready = 'true';

    button.addEventListener('click', () => {
      if (openAppSelector(bridge)) return;

      // A first tap while the app is still hydrating should still open the
      // selector as soon as its real trigger is created.
      const observer = new MutationObserver(() => {
        if (openAppSelector(bridge)) observer.disconnect();
      });
      observer.observe(bridge, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 3000);
    });

    updateState(button);
    document.addEventListener('locationChanged', () => updateState(button));
    new MutationObserver(() => updateState(button)).observe(bridge, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.addEventListener('DOMContentLoaded', mountLauncher);
  document.addEventListener('shopify:section:load', mountLauncher);
  document.addEventListener('shopify:section:reorder', mountLauncher);

  if (document.readyState !== 'loading') mountLauncher();
})();
